import {
  analyticsReduxRegistry,
  DATA_LAYER_SCOPES
} from "seneca-common/features/analytics";
import { getSchoolName } from "seneca-common/features/schools/analytics/register-data-layer-selectors";
import { getUserType } from "seneca-common/features/userType";

import {
  areSoundEffectsEnabled,
  getPreferredThemeMode,
  getRegion,
  getTeacherRole,
  getUserAccountType,
  getUserDisplayName,
  getUserEmail,
  getUserFamilyName,
  getUserGivenName,
  getUserHasPickedDisplayName,
  getUserId,
  getUserManagedBy,
  getUserNickName,
  getUserPhoneNumber,
  getUserYearGroup,
  isFirstUserSession,
  isSignedIn,
  isSignedInAsGuest,
  userHasSignedInBefore
} from "../state";

analyticsReduxRegistry.registerGlobalSelectorsToDataLayerScope(
  DATA_LAYER_SCOPES.USER,
  {
    userId: getUserId,
    displayName: getUserDisplayName,
    hasPickedDisplayName: getUserHasPickedDisplayName,
    email: getUserEmail,
    firstName: getUserGivenName,
    lastName: getUserFamilyName,
    school: getSchoolName, // TODO: remove this field once webapp version with schools scope has propagated
    phoneNumber: getUserPhoneNumber,
    accountType: getUserAccountType,
    nickName: getUserNickName,
    isSignedIn: isSignedIn,
    isSignedInAsGuest: isSignedInAsGuest,
    userHasSignedInBeforeOnThisDevice: userHasSignedInBefore,
    isFirstUserSession: isFirstUserSession,
    region: getRegion,
    yearGroup: getUserYearGroup,
    teacherRole: getTeacherRole,
    managedBy: getUserManagedBy,
    soundEffectsEnabled: areSoundEffectsEnabled,
    preferredThemeMode: getPreferredThemeMode,
    userType: getUserType
  }
);

analyticsReduxRegistry.registerUserPropertiesSelectorsToDataLayerScope({
  userId: getUserId,
  accountType: getUserAccountType,
  isSignedIn: isSignedIn,
  userHasSignedInBeforeOnThisDevice: userHasSignedInBefore,
  isFirstUserSession: isFirstUserSession,
  school: getSchoolName, // TODO: remove this field once webapp version with schools scope has propagated
  region: getRegion
});
